import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface CustomQtyBreakPricingParameter extends ApiParameter {
    productNumber: string;
    customerNumber: string;
}

const customUrl = "/api/v2/sxe/getquantitybreakpricing";

export async function getQtyBreakPricingService(
    parameter: CustomQtyBreakPricingParameter,
): Promise<ServiceResult<CustomQtyBreakPricingParameter>> {
    try {
        const result = await get<CustomQtyBreakPricingParameter>(
            `${customUrl}?productNumber=${encodeURIComponent(parameter.productNumber)}&customerNumber=${
                parameter.customerNumber
            }`,
        );
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (error.status === 404) {
            return {
                successful: false,
                errorMessage: "404 Not Found",
            };
        }
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
